// src/data/countryData.js
export const countryData = {
    "Cameroon": {
      name: "Cameroon",
      videoId: "ZS8GaXHP9D4",
      description: "Learn about Cameroon's rich cultural heritage and history."
    },
    "Togo": {
      name: "Togo",
      videoId: "0btPZcJsC0c",
      description: "Explore Togo's traditions and historical significance."
    },
    "Tanzania": {
      name: "Tanzania",
      videoId: "SVpc-Qpcx3A",
      description: "Discover Tanzania's diverse cultural heritage."
    },
    "Senegal": {
      name: "Senegal",
      videoId: "PR2u7gSj59g",
      description: "Experience Senegal's vibrant cultural traditions and history."
    },
    "Malawi": {
      name: "Malawi",
      videoId: "mIN98KtIY48",
      description: "Learn about Malawi's heritage and historical significance."
    },
    "Uganda": {
      name: "Uganda",
      videoId: "3YOrz1eSbGk",
      description: "Explore Uganda's cultural traditions and historical landmarks."
    },
    "Ethiopia": {
      name: "Ethiopia",
      videoId: "hYBKZMYH3Ts",
      description: "Discover Ethiopia's ancient history and cultural significance."
    },
    "Sierra Leone": {
      name: "Sierra Leone",
      videoId: "fU9X6ocMEgE",
      description: "Experience Sierra Leone's unique cultural heritage."
    },
    "Nigeria": {
      name: "Nigeria",
      videoId: "03vgI_LsrlU",
      description: "Learn about Nigeria's diverse cultural traditions and history."
    },
    "Democratic Republic of the Congo": {
      name: "Democratic Republic of the Congo",
      videoId: "dqL3AOo69Gc",
      description: "Discover the culture and history of the DRC."
    },
    "Gambia": {
      name: "Gambia",
      videoId: "BE5gm-pRBp8",
      description: "Explore the Gambia's vibrant traditions."
    },
    "Burkina Faso": {
      name: "Burkina Faso",
      videoId: "kcGpaVNcvd8",
      description: "Learn about Burkina Faso's unique heritage."
    },
    "Angola": {
      name: "Angola",
      videoId: "_rRFvbKvA8M",
      description: "Discover Angola's rich culture."
    },
    "Morocco": {
      name: "Morocco",
      videoId: "7yfQDmRoIvI",
      description: "Explore Morocco's history and culture."
    },
    "Eritrea": {
      name: "Eritrea",
      videoId: "4QidAlr6Jy0",
      description: "Learn about Eritrea's heritage."
    },
    "Madagascar": {
      name: "Madagascar",
      videoId: "2Du6pxoyk7I",
      description: "Discover Madagascar's unique biodiversity and culture."
    },
    "Ivory Coast": {
      name: "Ivory Coast",
      videoId: "FTSyPL0_OWc",
      description: "Explore the Ivory Coast's vibrant traditions."
    },
    "Liberia": {
      name: "Liberia",
      videoId: "zCegKC0eR4M",
      description: "Learn about Liberia's history and culture."
    },
    "Benin": {
      name: "Benin",
      videoId: "Y9KT5jIgfoY",
      description: "Discover Benin's cultural heritage."
    },
    "Gabon": {
      name: "Gabon",
      videoId: "thXaz8rKv5I",
      description: "Explore Gabon's natural beauty and culture."
    },
    "Mozambique": {
      name: "Mozambique",
      videoId: "ZSthLs4efoY",
      description: "Learn about Mozambique's history and people."
    },
    "South Africa": {
      name: "South Africa",
      videoId: "vp4Yra6B3iE",
      description: "Experience South Africa's diverse cultures."
    },
    "Egypt": {
      name: "Egypt",
      videoId: "qTXvO4nAHL0",
      description: "Explore Egypt's ancient and modern wonders."
    },
    "Somalia": {
      name: "Somalia",
      videoId: "cIlG4xmWH4Q",
      description: "Discover Somalia's history and culture."
    },
    "Zimbabwe": {
      name: "Zimbabwe",
      videoId: "06ZpKt3ub4M",
      description: "Learn about Zimbabwe's heritage."
    },
    "Seychelles": {
      name: "Seychelles",
      videoId: "62KYa6phtdg",
      description: "Explore the islands of Seychelles."
    },
    "Comoros": {
      name: "Comoros",
      videoId: "eLBia5ZUqt4",
      description: "Discover the Comoros islands."
    },
    // Newly added countries from the table
    "Algeria": {
      name: "Algeria",
      videoId: "9lm1rOOUJj8",
      description: "Discover Algeria's rich cultural heritage and historical significance."
    },
    "Botswana": {
      name: "Botswana",
      videoId: "WMmQzpw4djw",
      description: "Explore Botswana's diverse landscapes and cultural traditions."
    },
    "Burundi": {
      name: "Burundi",
      videoId: "P9JPJEqOdLc",
      description: "Learn about Burundi's unique heritage and cultural practices."
    },
    "Cabo Verde": {
      name: "Cabo Verde",
      videoId: "TEXRmWTxwyE",
      description: "Experience the vibrant culture and history of Cabo Verde."
    },
    "Central African Republic": {
      name: "Central African Republic",
      videoId: "07QeqIU_8_Q",
      description: "Discover the cultural richness of the Central African Republic."
    },
    "Chad": {
      name: "Chad",
      videoId: "43U47wWmpeM",
      description: "Explore Chad's diverse cultural heritage and traditions."
    },
    "Republic of the Congo": {
      name: "Republic of the Congo",
      videoId: "Lo_wflf1wsg",
      description: "Learn about the Republic of the Congo's cultural legacy."
    },
    "Djibouti": {
      name: "Djibouti",
      videoId: "HEKenTz7YZE",
      description: "Discover Djibouti's unique cultural heritage and history."
    },
    "Equatorial Guinea": {
      name: "Equatorial Guinea",
      videoId: "neDPxjGg9M4",
      description: "Explore Equatorial Guinea's rich cultural traditions."
    },
    "Eswatini": {
      name: "Eswatini",
      videoId: "Gxku64Hyk2c",
      description: "Experience Eswatini's cultural heritage and traditions."
    },
    "Guinea": {
      name: "Guinea",
      videoId: "ZdeM_nbxTcU",
      description: "Learn about Guinea's diverse cultural heritage and history."
    },
    "Guinea-Bissau": {
      name: "Guinea-Bissau",
      videoId: "OaTrH8d_ozo",
      description: "Discover Guinea-Bissau's unique cultural traditions."
    },
    "Kenya": {
      name: "Kenya",
      videoId: "tSlf-EMhnWM",
      description: "Explore Kenya's rich cultural heritage and diverse traditions."
    },
    "Lesotho": {
      name: "Lesotho",
      videoId: "BfVuwNdrUHE",
      description: "Learn about Lesotho's cultural heritage and mountain traditions."
    },
    "Libya": {
      name: "Libya",
      videoId: "8xSzdeY5QWY",
      description: "Discover Libya's ancient history and cultural significance."
    },
    "Mali": {
      name: "Mali",
      videoId: "6ndrzMaDQzc",
      description: "Explore Mali's rich cultural heritage and historical legacy."
    },
    "Mauritania": {
      name: "Mauritania",
      videoId: "XZURtYRQoKg",
      description: "Learn about Mauritania's cultural traditions and heritage."
    },
    "Mauritius": {
      name: "Mauritius",
      videoId: "lfWsAGQHwl4",
      description: "Discover Mauritius's diverse cultural heritage and island traditions."
    },
    "Namibia": {
      name: "Namibia",
      videoId: "QLDhCOY_spA",
      description: "Explore Namibia's unique cultural heritage and natural beauty."
    },
    "Niger": {
      name: "Niger",
      videoId: "jWJXIBIRKNg",
      description: "Learn about Niger's cultural traditions and historical significance."
    },
    "Rwanda": {
      name: "Rwanda",
      videoId: "dVqm40wcnL4",
      description: "Discover Rwanda's cultural heritage and traditions of resilience."
    },
    "São Tomé and Príncipe": {
      name: "São Tomé and Príncipe",
      videoId: "c8nwIMvDEFQ",
      description: "Explore the cultural heritage of São Tomé and Príncipe."
    },
    "South Sudan": {
      name: "South Sudan",
      videoId: "fScR9WwSjaM",
      description: "Learn about South Sudan's emerging cultural heritage and traditions."
    },
    "Sudan": {
      name: "Sudan",
      videoId: "iDpzZ6N4AHA",
      description: "Discover Sudan's rich cultural heritage and historical legacy."
    },
    "Tunisia": {
      name: "Tunisia",
      videoId: "aLeV4caUadU",
      description: "Explore Tunisia's cultural heritage and Mediterranean traditions."
    }
    // You can add more countries as needed
  };